import { generateSimulationQuery, generateExposureQuery } from "modules/smart-trade-rule-search/helpers"
import { ContentSetWithEscapedId, Classification, PositionSetInput, ModelMetadata } from "./types"

export interface GraphQLQuery {
  query: string
  variables: {
    modelId: string
    positionSet: PositionSetInput
    on: string
  }
}

function cleanPositionSet(positionSet: PositionSetInput): PositionSetInput {
  return {
    type: positionSet.type,
    id: positionSet.id,
    ...(positionSet.experimentId !== undefined && { experimentId: positionSet.experimentId }),
    ...(positionSet.weight !== undefined && { weight: positionSet.weight }),
    ...(positionSet.dates !== undefined && { dates: positionSet.dates }),
    ...(positionSet.segment !== undefined && { segment: positionSet.segment }),
    ...(positionSet.expand !== undefined && { expand: positionSet.expand }),
    ...(positionSet.fxHedgeEnabled !== undefined && { fxHedgeEnabled: positionSet.fxHedgeEnabled }),
  }
}

export function buildRulesQuery(
  modelId: string,
  endDate: string,
  positionSet: PositionSetInput,
  contentSets: ContentSetWithEscapedId[] | null,
  classifications: Classification[] | null,
  modelMetadata: ModelMetadata | null | undefined,
): GraphQLQuery | null {
  if (!modelId || !endDate || !positionSet || !contentSets || !classifications) {
    return null
  }

  const missingDataFiles = modelMetadata?.missingDataFiles || []
  const cleanedPositionSet = cleanPositionSet(positionSet)
  const simulationQueryPart = generateSimulationQuery(classifications)
  const exposureQueryPart = generateExposureQuery(contentSets, missingDataFiles)

  return {
    query: `query ($modelId: String!, $positionSet: PositionSetInput!, $on: Date!) {
      model(id: $modelId) {
        simulation(positionSet: $positionSet, from: $on, to: $on) {
          ${simulationQueryPart}
          ${exposureQueryPart}
        }
      }
    }`,
    variables: {
      modelId,
      positionSet: cleanedPositionSet,
      on: endDate,
    },
  }
}

export function validateQueryParams(
  modelId: string,
  endDate: string,
  positionSet: PositionSetInput | null | undefined,
): boolean {
  return Boolean(
    modelId
    && typeof modelId === "string"
    && endDate
    && typeof endDate === "string"
    && positionSet
    && typeof positionSet === "object",
  )
}
